// import appConfig from '@/utils/appConfig'
import store from '@/store'

export const formatEssentialManifest = manifest => manifest.map(coin => ({
  ...coin,
  addressRegex: coin.addressRegex.endsWith('$') ? coin.addressRegex : `${coin.addressRegex}$`,
  txRegex: coin.txRegex.endsWith('$') ? coin.txRegex : `${coin.txRegex}$`,
  label: coin.key.toUpperCase(),
  family: 'eth',
  essential: true,
}))

export function isCoinEssential(coinKey) {
  const list = store.state.analytics?.essentialCurrencyList
  return list?.some(c => c.key === coinKey) ?? false
}